import {Outlet, useLocation} from "react-router-dom";
import ScrollToTop from "../../util/ScrollToTop";
import React, {useEffect} from "react";
import {lazyLoadClarity, lazyLoadFacebookPixel, lazyLoadTikTokPixel} from "../../util/LazyLoadScripts";
import useGoogleAdsPageView from "../../hooks/useGoogleAdsPageView";

export default function FunnelRootLayout() {
    const location = useLocation();

    // Track PageView events for Google Ads
    useGoogleAdsPageView();

    // Grant consent only on webinar-related pages for retargeting
    // This includes: /webinar/*, /szkolenie*
    useEffect(() => {
        const isWebinarRelatedPage =
            location.pathname.startsWith('/webinar/') ||
            location.pathname.startsWith('/szkolenie');

        if (isWebinarRelatedPage) {
            try {
                // @ts-ignore
                if (typeof gtag !== 'undefined') {
                    // @ts-ignore
                    gtag('consent', 'update', {
                        'ad_storage': 'granted',
                        'ad_user_data': 'granted',
                        'ad_personalization': 'granted',
                        'analytics_storage': 'granted'
                    });
                }
            } catch (error) {
                console.error('Error granting consent on webinar page:', error);
            }
        }
    }, [location.pathname]);

    useEffect(() => {
        // Lazy load Facebook Pixel to avoid blocking initial render
        const initPixel = async () => {
            try {
                const ReactPixel = await lazyLoadFacebookPixel();
                ReactPixel.init(process.env.REACT_APP_FB_PIXEL_ID, undefined, {debug: false, autoConfig: true});
                ReactPixel.pageView();
            } catch (error) {
                console.error('Failed to load Facebook Pixel:', error);
            }
        };

        // Delay initialization to prioritize critical resources
        setTimeout(initPixel, 100);

        // Lazy load Clarity for analytics
        lazyLoadClarity('os3zpotjsv');

        // Lazy load TikTok Pixel for analytics
        lazyLoadTikTokPixel('D43I7ABC77U4N81AOIJG');
    }, []);

    return <>
        <ScrollToTop/>
        <Outlet/>
    </>
}